(function () {
  'use strict';

  class ProductGroupSwitcher {
    constructor() {
      this.bindEvents();
    }

    bindEvents() {
      document.addEventListener('change', function (e) {
        if (e.target.matches('[data-product-color-input]')) {
          var productUrl = e.target.getAttribute('data-product-url');
          if (productUrl) {
            window.location.href = productUrl;
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new ProductGroupSwitcher();
    });
  } else {
    new ProductGroupSwitcher();
  }
})();
